export const MANAGE_VIEW_PATH = "/manage";